"use client";

import copy from "copy-to-clipboard";
import { useContext, useEffect } from "react";
import {
  FacebookMessengerShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "next-share";
import { isWindow } from "@/service/render-environment";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { ChevronDownIcon, Link2Icon, Share2Icon } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { FacebookIcon } from "@/svg/brandings/facebook-icon";
import { XTwitterIcon } from "@/svg/brandings/x-twitter-icon";
import { MessengerIcon } from "@/svg/share/messenger-icon";

export const Share = () => {
  useEffect(() => {}, []);
  const { logView } = useContext(ResourceContext);

  return (
    <div className="flex items-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className={"gap-0 pr-0 hover:scale-100"}>
            <Share2Icon className="h-5 w-5" />
            <span className="ml-2 text-sm font-normal">Udostępnij</span>
            <div className={"ml-4 flex h-10 items-center border-l px-3"}>
              <ChevronDownIcon className="m h-4 w-4" />
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="font-inter w-[168px] text-sm font-normal text-black"
        >
          <div className={"w-full [&_button]:w-full"}>
            <TwitterShareButton
              url={isWindow() ? window.location.href : ""}
              onClick={() => {
                logEvent("publication_shared", logView, {
                  type: "twitter",
                });
              }}
            >
              <DropdownMenuItem className={"flex items-center gap-2"}>
                <XTwitterIcon />X (Twitter)
              </DropdownMenuItem>
            </TwitterShareButton>
          </div>
          <div className={"w-full [&_button]:w-full"}>
            <FacebookShareButton
              url={isWindow() ? window.location.href : ""}
              onClick={() => {
                logEvent("publication_shared", logView, {
                  type: "facebook",
                });
              }}
            >
              <DropdownMenuItem className={"flex items-center gap-2"}>
                <FacebookIcon />
                Facebook
              </DropdownMenuItem>
            </FacebookShareButton>
          </div>

          <div className={"mb-1 w-full border-b pb-1 [&_button]:w-full"}>
            <FacebookMessengerShareButton
              url={isWindow() ? window.location.href : ""}
              onClick={() => {
                logEvent("publication_shared", logView, {
                  type: "messenger",
                });
              }}
            >
              <DropdownMenuItem className={"flex items-center gap-2"}>
                <MessengerIcon />
                Messenger
              </DropdownMenuItem>
            </FacebookMessengerShareButton>
          </div>

          <DropdownMenuItem
            onClick={() => {
              logEvent("publication_shared", logView, {
                type: "copy_link",
              });
              copy(window.location.href);
            }}
            className={"flex items-center gap-2 text-black opacity-100"}
          >
            <Link2Icon size={16} className={"stroke-black"} />
            Skopiuj link
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
